// extracted by mini-css-extract-plugin
export default {"landscape":"Landscape_landscape__-Z0+R","landscapeImg":"Landscape_landscapeImg__o8AY-"};